module.exports = __webpack_public_path__ + "img/thumb.03bb2108.png";